module.exports = __webpack_public_path__ + "static/media/english.11d41fdc.svg";